import { render, staticRenderFns } from "./GastroPancolonscopiaList.vue?vue&type=template&id=4d9cd265"
import script from "./GastroPancolonscopiaList.vue?vue&type=script&lang=js"
export * from "./GastroPancolonscopiaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports